export default class Tachyon {

    static serialize(obj) {
        const str = []
        for (const p in obj)
            if (obj.hasOwnProperty(p)) {
                str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]))
            }
        return str.join('&')
    }

    static stripQs(url) {
        if (typeof url === 'string') {
            return url.split("?")[0];
        }
    }

    static fetch(image, options) {

        if (!image) {
            return
        }

        if (typeof image === 'string' && typeof options === 'object') {

            if (document.body.className.indexOf('webp') !== -1) {
                options.webp = true;
            }
            return `${this.stripQs(image)}?${this.serialize(options)}`
        }

        return image
    }

    static crop(width, height) {

    }
}



// WEBPACK FOOTER //
// ./src/whatson/utils/tachyon.js